import { render } from "./GoalsPageHeader.vue?vue&type=template&id=31f9d8bc&scoped=true"
import script from "./GoalsPageHeader.vue?vue&type=script&lang=js"
export * from "./GoalsPageHeader.vue?vue&type=script&lang=js"

import "./GoalsPageHeader.vue?vue&type=style&index=0&id=31f9d8bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31f9d8bc"

export default script